import * as Utils from '../../../utils/helper';

export const SubscriptionEntry = ({subscription}) => {
    const enabled = Utils.isTrue(subscription.enabled);

    return (
        <tr>
            <td className="align-middle">
                {subscription.name}
            </td>
            <td className="align-middle">
                {String(subscription.creationTime).split('T')[0]}
            </td>
            <td className="align-middle">
                {subscription.quantity}
            </td>
            <td className="align-middle">
                {enabled ? 'yes' : 'no'}
            </td>           
        </tr>
    )
}